export default {

    'project.app.Footer.text': 'PA Project - Area de Enxeñaría Telemática - Universidade da Coruña',
    'project.app.Header.home': 'Inicio',
    'project.app.Header.logout': 'Saír',
    'project.app.Home.welcome': '¡Contido da páxina principal de PA Project!',
    
    'project.global.buttons.addStep': 'Engadir Paso',
    'project.global.buttons.previousStep': 'Paso Anterior',
    'project.global.buttons.nextStep': 'Seguinte Paso',
    'project.global.buttons.Play1': 'Reproducir',
    'project.global.buttons.Stop': 'Parar',

    'project.global.buttons.undo': 'Desfacer',
    'project.global.buttons.clear': 'Borrar',
    'project.global.buttons.download': 'Descargar',

    'project.global.buttons.team_selection': 'Selección de Equipo',
    'project.global.buttons.season_selection': 'Selección de Tempada',
    'project.global.buttons.player_selection': 'Selección de Xogadores',
    'project.global.buttons.exercises_selection': 'Selección de Exercicios',
    'project.global.buttons.stretching_selection': 'Selección de Estiramentos',
    'project.global.buttons.lesion_selection': 'Selección de Lesións',
    'project.global.buttons.play_selection': 'Selección de Xogadas',

    'project.calendar.buttons.editEvent': 'Editar Evento',
    'project.calendar.buttons.addEvent': 'Engadir Evento',
    'project.calendar.buttons.deleteEvent': 'Eliminar Evento',





















    'project.common.ErrorDialog.title': 'Erro',
    'project.global.buttons.signin': 'Iniciar Sesión',
    'project.global.buttons.charts': 'Gráficos',
    'project.global.buttons.calendar': 'Calendario',
    'project.global.buttons.users': 'Usuarios',
    'project.users.fields.remove' : 'Eliminar',

    'project.global.list.users': 'Lista de Usuarios',
    'project.global.create.users': 'Crear Usuario',
    'project.global.buttons.board': 'Taboado',
    'project.global.buttons.animation': 'Animación',
    'project.global.buttons.general': 'Xeral',
    
    'project.global.buttons.statistics': 'Estatísticas',
    'project.global.buttons.home': 'Inicio',

    'project.global.buttons.filter': 'Filtro',

    'project.global.buttons.find': 'Buscar',
    'project.global.buttons.cancel': 'Cancelar',
    'project.global.buttons.close': 'Cerrar',
    'project.global.buttons.next': 'Seguinte',
    'project.global.buttons.ok': 'OK',
    'project.global.buttons.back': 'Anterior',
    'project.global.buttons.save': 'Gardar',
    'project.global.exceptions.NetworkError': 'Erro de comunicación',
    'project.global.fields.date': 'Data',
    'project.global.fields.email': 'Correo electrónico',
    'project.global.fields.firstName': 'Nome',
    'project.global.fields.lastName': 'Apelidos',
    'project.global.fields.name': 'Nome',
    'project.global.fields.role': 'Rol',
    'project.global.fields.password': 'Contrasinal',

    'project.global.fields.currentPassword': 'Contrasinal Actual',
    'project.global.fields.newPassword': 'Nova Contrasinal',
    'project.global.fields.confirmPassword': 'Confirmar Contrasinal',

    'project.global.fields.postalAddress': 'Dirección postal',
    'project.global.fields.postalCode': 'Código postal',
    'project.global.fields.userName': 'Usuario',
    'project.global.fields.userName1': 'Nome de Usuario',
    'project.global.validator.email': 'Introduzca unha dirección de correo electrónico correcta',
    'project.global.validator.passwordsDoNotMatch': 'As contrasinais non coinciden',
    'project.global.validator.required': 'Campo obrigatorio',

    'project.users.ChangePassword.fields.confirmNewPassword': 'Confirmar contrasinal nova',
    'project.users.ChangePassword.fields.newPassword': 'Contrasinal nova',
    'project.users.ChangePassword.fields.oldPassword': 'Contrasinal antiga',
    'project.users.ChangePassword.title': 'Cambiar contrasinal',
    'project.users.Login.title': 'Autenticarse',
    'project.users.SignUp.fields.confirmPassword': 'Confirmar contrasinal',
    'project.users.SignUp.title': 'Rexistrarse',
    'project.users.UpdateProfile.title': 'Actualizar perfil',
    
    'project.users.profile.title': 'Perfil',

    'project.teams.FindTeamByName.noTeam': 'Non se encontraron equipos',
    'project.seasons.FindSeason.noSeason': 'Non se encontraron tempadas',

    'project.teams.fields.teams' : 'Equipos',
    'project.seasons.fields.seasons' : 'Tempadas',
    'project.lesion.fields.lesion' : 'Lesións',
    'project.trainings.fields.trainings' : 'Adestramentos',
    'project.games.fields.games' : 'Partidos',
    'project.stretchings.fields.stretchings' : 'Estiramentos',
    'project.exercises.fields.exercises' : 'Exercicios',

    'project.players.fields.players' : 'Xogadores',
    'project.statistics.fields.addGameStatistics' : 'Engadir Estatísticas Partido',
    'project.statistics.fields.game' : 'Estatísticas Partido',

    'project.teams.fields.team' : 'Equipo',
    'project.seasons.fields.season' : 'Tempada',
    'project.games.fields.game' : 'Partido',
    'project.players.fields.player' : 'Xogador',

    //exercises
    'project.exercises.fields.addExercise' : 'Engadir Exercicio',
    'project.exercises.fields.updateExercise' : 'Actualizar Exercicio',
    'project.exercises.fields.name' : 'Nome',
    'project.exercises.fields.description' : 'Descripción',
    'project.exercises.fields.objective' : 'Obxectivo',
    'project.exercises.fields.type' : 'Tipo Exercicio',
    'project.exercises.fields.typeOnly' : 'Tipo',
    'project.exercises.fields.tactic' : 'Táctico',
    'project.exercises.fields.technique' : 'Técnico',
    'project.exercises.fields.physical' : 'Físico',
    'project.exercises.fields.globalized' : 'Globalizado',
    'project.exercises.fields.specific' : 'Específico',
    'project.exercises.fields.psychological' : 'Psicolóxico',
    'project.exercises.fields.strategy' : 'Estratexia',
    'project.exercises.fields.preMatch' : 'PrePartido',

    'project.exercises.fields.myExercises' : 'Meus Exercicios',


    //games
    'project.games.fields.addGame' : 'Engadir Partido',
    'project.games.fields.updateGame' : 'Actualizar Partido',
    'project.games.fields.date' : 'Data',
    'project.games.fields.rival' : 'Rival',
    'project.games.fields.myGames' : 'Meus Partidos',
    'project.games.fields.removeGame' : 'Eliminar Partido',

    //lesion
    'project.lesion.fields.addLesion' : 'Engadir Lesión',
    'project.lesion.fields.updateLesion' : 'Actualizar Lesión',
    'project.lesion.fields.lesionName' : 'Nombre',
    'project.lesion.fields.medication' : 'Medicación',
    'project.lesion.fields.lesionType' : 'Tipo',
    'project.lesion.fields.muscle' : 'Muscular',
    'project.lesion.fields.tendon' : 'Tendinosa',
    'project.lesion.fields.joint' : 'Articular',
    'project.lesion.fields.spine' : 'Columna Vertebral',
    'project.lesion.fields.psychological' : 'Psicoloxica',
    'project.lesion.fields.withLesion' : 'Lesionados',
    'project.lesion.fields.myLesion' : 'Miñas Lesións',
    'project.lesion.fields.injured' : 'Ferido',

    //notes
    'project.notes.fields.note' : 'Nota',
    'project.notes.fields.addNote' : 'Engadir Nota',
    'project.notes.fields.updateNote' : 'Actualizar Nota',
    'project.notes.fields.title' : 'Título',
    'project.notes.fields.myNotes' : 'Miñas Notas',
    'project.notes.fields.notes' : 'Notas',
    //players
    'project.players.fields.addPlayer' : 'Engadir Xogador',
    'project.players.fields.updatePlayer' : 'Actualizar Xogador',
    'project.players.fields.name' : 'Nome',
    'project.players.fields.playerName' : 'Nome Xogador',
    'project.players.fields.primaryLastName' : 'Primer Apelido',
    'project.players.fields.secondLastName' : 'Segundo Apelido',
    'project.players.fields.position' : 'Posición',
    'project.players.fields.pointGuard' : 'Base',
    'project.players.fields.shootingGuard' : 'Escolta',
    'project.players.fields.smallForward' : 'Alero',
    'project.players.fields.powerForward' : 'Ala Pívot',
    'project.players.fields.center' : 'Pívot',
    'project.players.fields.trends' : 'Tendencias',
    'project.players.fields.phoneNumber' : 'Número Tfl',
    'project.players.fields.email' : 'Email',
    'project.players.fields.dni' : 'Dni',
    'project.players.fields.findPlayerByDni' : 'Buscar Xogador por Dni',
    'project.players.fields.findPlayerByNameAndSurnames' : 'Buscar Xogador por nomes e apelidos',
    'project.players.fields.nameAndSurnames' : 'Nome e apelidos',
    'project.players.fields.clear' : 'Reiniciar',


    //plays
    'project.plays.fields.addPlay' : 'Engadir Xogada',
    'project.plays.fields.updatePlay' : 'Actualizar Xogada',
    'project.plays.fields.play' : 'Xogada',
    'project.plays.fields.attack' : 'Ataque',
    'project.plays.fields.defense' : 'Defensa',
    'project.plays.fields.gesture' : 'Xesto',
    'project.plays.fields.pointGuardText' : 'Base Texto',
    'project.plays.fields.shootingGuardText' : 'Escolta Texto',
    'project.plays.fields.smallForwardText' : 'Alero Texto',
    'project.plays.fields.powerForwardText' : 'Ala Pívot Texto',
    'project.plays.fields.centerText' : 'Pívot Texto',


    //seasons
    'project.seasons.fields.addSeason' : 'Engadir Tempada',
    'project.plays.fields.updateSeason' : 'Actualizar Tempada',
    'project.seasons.fields.startDate' : 'Data Inicio',
    'project.seasons.fields.endDate' : 'Data Fin',
    'project.seasons.fields.name' : 'Nome',
    'project.seasons.fields.allSeasons' : 'Tempada',
    'project.seasons.fields.seasonsBetweenTwoDates' : 'Tempadas por datas',

    //statistics
    'project.statistics.fields.myteam' : 'Meu Equipo',
    'project.statistics.fields.myrival' : 'Rival',

    'project.statistics.fields.playerGameStatistics' : 'Estatísticas Xogador Partido',
    'project.statistics.fields.statistics' : 'Estatísticas',

    'project.statistics.fields.totalPoints' : 'Total Puntos',

    'project.statistics.fields.totalPointsTeam1' : 'Puntos Equipo',
    'project.statistics.fields.totalPointsRival1' : 'Puntos Rival',

    'project.statistics.fields.totalThreePointShots' : 'Tiros de 3',
    'project.statistics.fields.totalSetShots' : 'Tiros de campo',
    'project.statistics.fields.totalFreeShots' : 'Tiros libres',

    'project.statistics.fields.totalFailThreePointShots' : 'Total tiros de 3 errados',
    'project.statistics.fields.totalfailSetShots' : 'Total tiros de campo errados',
    'project.statistics.fields.totalfailFreeShots' : 'Total tiros libres errados',

    'project.statistics.fields.totalRebounds' : 'Rebotes',
    'project.statistics.fields.totalBlockedShot' : 'Tapóns',
    'project.statistics.fields.totalAssists' : 'Asistencias',

    'project.statistics.fields.totalPersonalFouls' : 'Faltas Personais',
    'project.statistics.fields.totalTechnicalFouls' : 'Faltas Técnicas',
    'project.statistics.fields.totalUnsportsmanlikeFouls' : 'Faltas Antideportivas',

    'project.statistics.fields.team_rival' : '(Mi Equipo - Rival)',

    'project.statistics.fields.failShots' : 'Fallou',
    
    'project.statistics.fields.shotsFailed' : 'Tiros faiados',
    'project.statistics.fields.shots' : 'Tiros anotados',

    'project.statistics.fields.addPlayerGameStatistics' : 'Engadir Estatísticas Jugador Partido',

    'project.statistics.fields.duration' : 'Duración (min)',
    'project.statistics.fields.minutes' : 'Minutos',

    'project.statistics.fields.totalPointsRival' : 'Total Puntos Rival',
    'project.statistics.fields.totalThreePointShotsRival' : 'Total tiros de 3 Rival',
    'project.statistics.fields.totalSetShotsRival' : 'Total tiros de campo Rival',
    'project.statistics.fields.totalFreeShotsRival' : 'Total tiros libres Rival',

    'project.statistics.fields.totalReboundsRival' : 'Total Rebotes Rival',
    'project.statistics.fields.totalBlockedShotRival' : 'Total Tapóns Rival',
    'project.statistics.fields.totalAssistsRival' : 'Total Asistencias Rival',

    'project.statistics.fields.totalPersonalFoulsRival' : 'Total Faltas Personais Rival',
    'project.statistics.fields.totalTechnicalFoulsRival' : 'Total Faltas Técnicas Rival',
    'project.statistics.fields.totalUnsportsmanlikeFoulsRival' : 'Total Faltas Antideportivas Rival',



    'project.statistics.fields.threePointShots' : 'Tiros de 3',
    'project.statistics.fields.setShots' : 'Tiros de campo',
    'project.statistics.fields.freeShots' : 'Tiros libres',

    'project.statistics.fields.failThreePointShots' : 'Tiros de 3 fallados',
    'project.statistics.fields.failSetShots' : 'Tiros de campo fallados',
    'project.statistics.fields.failFreeShots' : 'Tiros libres fallados',

    'project.statistics.fields.rebounds' : 'Rebotes',
    'project.statistics.fields.blockedShot' : 'Tapóns',
    'project.statistics.fields.assists' : 'Asistencias',

    'project.statistics.fields.personalFouls' : 'Faltas Personais',
    'project.statistics.fields.technicalFouls' : 'Faltas Técnicas',
    'project.statistics.fields.unsportsmanlikeFouls' : 'Faltas Antideportivas',

    'project.statistics.fields.update' : 'Actualizar',
    'project.statistics.fields.updateGameStatistics' : 'Actualizar Estatísticas Partido',
    'project.statistics.fields.updatePlayerGameStatistics' : 'Actualizar Estatísticas Xogador Partido',


    //stretchings
    'project.stretchings.fields.addStretching' : 'Engadir Estiramento',
    'project.stretchings.fields.myStretchings' : 'Meus Estiramentos',

    'project.stretchings.fields.stretchingName' : 'Nome',
    'project.stretchings.fields.stretchingType' : 'Tipo',
    'project.stretchings.fields.hamstrings' : 'Isquiotibiales',
    'project.stretchings.fields.buttocks' : 'Nádegas',
    'project.stretchings.fields.calf' : 'Xemelgos',
    'project.stretchings.fields.adductors' : 'Adutores',
    'project.stretchings.fields.shoulder' : 'Ombreiro',
    'project.stretchings.fields.quadriceps' : 'Cuádriceps',
    'project.stretchings.fields.back' : 'Espalda',
    'project.stretchings.fields.pectoral' : 'Pectoral',
    'project.stretchings.fields.crotch' : 'Ingle',
    'project.stretchings.fields.triceps' : 'TrÍceps',
    'project.stretchings.fields.updateStretching' : 'Actualizar Estiramento',
    
    //teams
    'project.teams.fields.changeTeam' : 'Cambiar Equipo',

    'project.teams.fields.name' : 'Nome',
    'project.teams.fields.arena' : 'Estadio',
    'project.teams.fields.owner' : 'Propiedade',

    'project.teams.fields.addTeamToSeason' : 'Engadir Equipo a Tempada',
    
    'project.teams.fields.addTeam' : 'Engadir Equipo',
    'project.teams.fields.updateTeam' : 'Actualizar Equipo',
    'project.teams.fields.teamName' : 'Nome Equipo',

    'project.plays.fields.plays' : 'Xogadas',

    'project.teams.fields.allTeams' : 'Equipos',

    //trainings
    'project.trainings.fields.addTraining' : 'Engadir Adestramentos',
    'project.trainings.fields.myTrainings' : 'Meus Adestramentos',
    'project.trainings.fields.removeTraining' : 'Eliminar Adestramentos',

    'project.trainings.fields.updateTraining' : 'Actualizar Adestramentos',
    
    'project.trainings.fields.objective' : 'Obxectivo',

    'project.trainings.fields.training' : 'Adestramento',
    'project.trainings.fields.durationOnly' : 'Duración',

    //sidebar
    'project.sidebar.fields.club' : 'Clube',
    'project.sidebar.fields.events' : 'Eventos',
    'project.sidebar.fields.physicalHealth' : 'Saúde Física',
}
